export default {
  LeftMenu: {
    UserRole: "Người dùng - Vai trò",
    UserList: "Danh sách người dùng",
    DepartmentList: "Danh sách phòng ban",
    AgreementLicenseList: "Lịch sử thỏa thuận",
    OrganizationInfo: "Thông tin đơn vị",
    User: "Người dùng",
    Control: 'Control',
    EmployeeList: 'Nhân viên',
    CollapseText: 'Thu gọn',
    InventoryItem: 'Kho',
    Account: 'Tài khoản',
    Dashboard: 'Tổng quan',
    Treasury: 'Kho bạc',
    Etreasury: 'Kho bạc điện tử',
    CA: 'Tiền mặt',
    BA: 'Tiền gửi',
    SU: 'Công cụ dụng cụ',
    FA: 'Tài sản cố định',
    Salary: 'Tiền lương',
    PU: 'Mua hàng',
    SA: 'Bán hàng',
    Invoice: 'Hóa đơn',
    Tax: 'Thuế',
    GL: 'Tổng hợp',
    Report: 'Báo cáo',
    Setting: "Thiết lập",
    TaskType: "Loại việc",
    PriorityLevel: "Mức độ ưu tiên",
    RatingWork: "Đánh giá công việc",
    Deadline: "Thời gian quá hạn",
    AssignmentGroup: "Nhóm giao việc",
    Authorization: "Ủy quyền",
    Task: "Công việc",
    ChooseUser: "Thêm người được ủy quyền",
    NeedToDo:"Tôi cần thực hiện",
    NeedToApprove:"Tôi cần phê duyệt",
    AssginedByMe:"Tôi đã giao/phụ trách",
    RelatedToMe:"Liên quan đến tôi",
    DoneByMe:"Tôi đã thực hiện",
    Draft:"Dự thảo",
    Handover: "Điều phối bàn giao",
    All:"Tất cả",
  },
  Nav: {
    PostedDate: 'Ngày hạch toán:',
    Search: 'Tìm chứng từ',
  },

  MessageEvent: {
    Save: "Lưu dữ liệu thành công",
  },

  Content:{
    Handover: "Điều phối bàn giao",
    SearchTaskByName: "Tìm theo tên công việc",
    HandoverDesc: "Điều phối bàn giao những công việc đang thực hiện của người này cho người khác",
    AddTaskType:"Thêm loại việc",
    AddTaskPriorityLevel:"Thêm mức độ ưu tiên",
    TextTaskType:"Nhập tên loại việc",
    TextFullName: 'Nhập họ tên',
    FullName: 'Họ tên',
    TextJobTitle: 'Nhập chức vụ/chức danh',
    JobTitle: 'Chức vụ/Chức danh',
    TextPhoneNumber: 'Nhập số điện thoại',
    PhoneNumber: 'Số điện thoại',
    TextEmail: 'Nhập email',
    Email: 'Email',
    ChooseUser: "Thêm người được ủy quyền",
    ChooseUserHandoverFrom: "Thêm người cần bàn giao",
    HandoverNote: "Lưu ý <span class='text-danger'>*</span>: Vai trò trong công việc của người cần bàn giao sẽ chuyển cho người được bàn giao",
    ChooseUserHandoverTo: "Thêm người được bàn giao",
    GroupSearch: "Tìm theo tên nhóm",
    AddAssignmentGroup: "Thêm nhóm giao việc",
    AddMember: "Thêm thành viên",
    TextPriorityLevel: "Nhập tên mức ưu tiên",
    SettingTaskType: "Thiết lập loại việc",
    GeneralSetting: 'Thiết lập chung',
    LicenseList: 'Lịch sử thỏa thuận',
    ListTaskTypeManager: "Danh sách loại việc",
    SettingAuthorization: "Thiết lập ủy quyền",
    AuthorizationUpToDown: "Ủy quyền cho người cấp dưới thay mình thực hiện công việc",
    SettingDeadline: "Thiết lập thời gian quá hạn",
    DeadlineTextWarning: "Thời gian quá hạn vượt quá thời gian này thì công việc không thể tiếp tục thực hiện hoặc phải yêu cầu gia hạn",
    SettingRateWork: "Thiết lập đánh giá công việc",
    TextRateWork: "Cài đặt số sao tối đa có thể đánh giá tương ứng với số ngày quá hạn",
    SettingPriority: "Thiết lập mức độ ưu tiên",
    PriorityLevelManager: "Danh sách mức độ ưu tiên",
    SettingAssignmentGroup: "Thiết lập nhóm giao việc",
    TextAssignmentGroup: "Tạo nhóm gồm các người dùng có chung đặc điểm, chuyên môn,... để giao việc nhanh",
    Membersearch: "Tìm theo tên thành viên",
    RatingMax: "Đánh giá tối đa",
    IfDeadline: "nếu công việc trễ hạn hoàn thành",
    Day: "ngày",
    DeadlineTextFirst: 'Là thời gian kể từ khi quá',
    DeadlineTextLast: ', người chủ trì vẫn cập nhật được tiến độ công việc. Sau thời gian này, công việc sẽ chuyển trạng thái "Không hoàn thành"',
    Deadline: 'Hạn hoàn thành',
    RatingValidate: (first, last) =>
      `Số ngày quá hạn được đánh giá ${first} sao phải lớn hơn số ngày quá hạn được đánh giá ${last} sao`,
    PersonalSetting: 'Thiết lập cá nhân',
    DefaultValue: 'Giá trị mặc định',
    DefaultValueDescription: 'Hiển thị khi thêm mới công việc'
  }
};
